import demoTrackWav from "../assets/audio/demo_track.wav";

/** Bundled demo audio when a track has no `resource` / `mp3_resource` (or blob is missing). */
export const WL_DEMO_TRACK_AUDIO_PLACEHOLDER = demoTrackWav;
export const WL_DEMO_TRACK_AUDIO_PLACEHOLDER_MIME = "audio/wav";
